import { cn } from '../../lib/cn'
import { accentAlpha, onLight } from '../../lib/slug'
import type { ProductVariant } from '../../types'

interface VariantSelectorProps {
  variants: ProductVariant[]
  activeId: string
  onChange: (id: string) => void
  accent: string
}

export function VariantSelector({ variants, activeId, onChange, accent }: VariantSelectorProps) {
  if (variants.length <= 1) {
    return (
      <div className="inline-flex items-center gap-2 rounded-full border border-sand-200 bg-white px-4 py-2 text-sm font-medium text-ink-700">
        Pack size: {variants[0]?.packSize}
      </div>
    )
  }
  return (
    <div role="radiogroup" aria-label="Choose pack size" className="flex flex-wrap gap-2.5">
      {variants.map((v) => {
        const active = v.id === activeId
        return (
          <button
            key={v.id}
            role="radio"
            aria-checked={active}
            onClick={() => onChange(v.id)}
            className={cn(
              'min-w-[4.5rem] rounded-lg border px-4 py-2.5 text-sm font-semibold transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime-bright',
              active ? 'shadow-soft' : 'border-sand-200 bg-white text-ink-700 hover:border-ink-300',
            )}
            style={active ? { borderColor: accent, color: onLight(accent), background: accentAlpha(accent, 0.08) } : undefined}
          >
            {v.label}
          </button>
        )
      })}
    </div>
  )
}
